import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Only include timezone header for certain requests
    if (config.url.includes("/citas")) {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      config.headers.timezone = timezone;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
